import React from 'react';

interface ProrrogacaoPrazoFormProps {
	values?: any
	onSubmit: (event: any) => void
}

const ProrrogacaoPrazoForm = React.forwardRef((props: ProrrogacaoPrazoFormProps, ref: React.Ref<any>) => {
	const submitForm = React.useCallback(() => {
		document.getElementById('prorrogacao_prazo_form_submit')?.click();
	}, []);

	const resetForm = React.useCallback(() => {
		document.getElementById('prorrogacao_prazo_form_reset')?.click();
	}, []);

	React.useImperativeHandle(ref, () => ({
		submit: submitForm,
		reset: resetForm,
	}), [resetForm, submitForm]);

	const onSubmit = React.useCallback((event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		event.stopPropagation();

		const form = event.target as HTMLFormElement;
		const formData = new FormData(form);
		const formValues = Object.fromEntries(formData);

		props.onSubmit(formValues);
	}, [props]);

	const calcDueDate = React.useCallback((daysToAdd: number) => {
		const dueTime = new Date(props.values?.encerramento?.ultimo_dia_em_campo);
		const increment = 120 + (daysToAdd || 0);
		dueTime.setDate(dueTime.getDate() + increment);
		return dueTime;
	}, [props.values?.encerramento?.ultimo_dia_em_campo]);

	const [dueDatePreview, setDueDatePreview] = React.useState<Date | null>(null);

	React.useEffect(() => {
		setDueDatePreview(calcDueDate(0));
	}, [calcDueDate]);

	return (

		<form id="prorrogacao_prazo_form" onSubmit={onSubmit}>
			<div className='row'>
				<div className='col-md-6'>
					<div className='form-group'>
						<label htmlFor='dias_de_prorrogacao'>Dias de prorrogação</label>
						<input
							id="dias_de_prorrogacao"
							name="dias_de_prorrogacao"
							type='number'
							min={1}
							step={1}
							className='form-control'
							required
							onChange={(event) => {
								const days = parseInt(event.target.value);
								setDueDatePreview(calcDueDate(days));
							}}
						/>
					</div>
				</div>

				<div className='col-md-6'>
					<div className='form-group'>
						<label htmlFor='due_due_date_preview'>Novo encerramento</label>
						<input
							readOnly
							disabled
							id="due_date_preview"
							name="due_date_preview"
							type='text'
							className='form-control'
							value={dueDatePreview?.toLocaleDateString('pt-BR') ?? ''}
						/>
					</div>
				</div>

				<div className='col-md-12'>
					<div className='form-group'>
						<label htmlFor='justificativa'>Justificativa</label>

						<textarea
							id='justificativa'
							name='justificativa'
							required
							minLength={10}
							maxLength={150}
							className='form-control'
						/>

					</div>
				</div>
			</div>

			<input id="prorrogacao_prazo_form_reset" type='reset' style={{ display: 'none' }} />
			<input id="prorrogacao_prazo_form_submit" type='submit' style={{ display: 'none' }} />
		</form>
	);
});

ProrrogacaoPrazoForm.displayName = 'ProrrogacaoPrazoForm';

export default ProrrogacaoPrazoForm;
